
import { Component, Vue } from 'vue-property-decorator';
import LayoutDefault from '@/layouts/LayoutDefault.vue';
import { Dish, DishCourseEnum, Restaurant } from '@/api/model';
import MenuEngineeringLogic from '@/logic/menu-engineering/MenuEngineeringLogic';
import Calculator from '@/logic/menu-engineering/Calculator';
import { ScoredDish } from '@/logic/menu-engineering/ScoredDish';
import Score from '@/logic/menu-engineering/Score';
import ResultCategory from '@/components/menu-engineering/ResultCategory.vue';

@Component({
  components: { LayoutDefault, ResultCategory },
})
export default class MenuEngineeringResults extends Vue {
  courses?: string[];

  categories?: string[];

  get state() {
    return this.$store.state.menuEngineering;
  }

  get course(): DishCourseEnum {
    return this.state.activeCourse;
  }

  get dishes(): ScoredDish[] {
    return Calculator.calculate(this.state.dishes);
  }

  get restaurants(): Restaurant[] {
    return this.$store.state.restaurant.restaurants;
  }

  beforeCreate() {
    this.courses = MenuEngineeringLogic.getCourses();
    this.categories = MenuEngineeringLogic.allCategories();
  }

  created() {
    this.getRestaurants();
    this.getDishes();
  }

  async getRestaurants() {
    await this.$store.dispatch('restaurant/getRestaurants');
  }

  getDishes() {
    this.$store.dispatch('menuEngineering/getDishes');
  }

  getCurrentCourseDishes(restaurantId: string): Dish[] {
    return MenuEngineeringLogic.filterDishes(
      this.dishes,
      restaurantId,
      this.course,
    );
  }

  getCourseDishCount(restaurantId: string): number {
    return this.getCurrentCourseDishes(restaurantId).length;
  }

  getDishCount(restaurantId: string, category: Score): number {
    const categoryDishes = this.getCurrentCourseDishes(restaurantId).filter(
      (dish: ScoredDish) => dish.score === category,
    );
    return categoryDishes.length;
  }

  setCourse(course: DishCourseEnum) {
    this.$store.commit('menuEngineering/setActiveCourse', course);
  }
}
